import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import { CreateKycVerificationInput, CreateKycVerificationPayload } from "@oysterhr/schema"

const CREATE_KYC_VERIFICATION = gql`
  mutation CreateKycVerification($userId: ID!, $sessionId: String!, $sessionUrl: String!) {
    createKycVerification(
      input: { userId: $userId, sessionId: $sessionId, sessionUrl: $sessionUrl }
    ) {
      errors
    }
  }
`

export const useCreateKycVerification = (
  options?: InjectedOptions<CreateKycVerificationPayload, CreateKycVerificationInput>,
) =>
  useMutation<CreateKycVerificationPayload, CreateKycVerificationInput>(
    CREATE_KYC_VERIFICATION,
    options,
  )
